import { render, staticRenderFns } from "./BookingFormAdditionalInfoTab.vue?vue&type=template&id=0021b753&scoped=true"
import script from "./BookingFormAdditionalInfoTab.vue?vue&type=script&lang=js"
export * from "./BookingFormAdditionalInfoTab.vue?vue&type=script&lang=js"
import style0 from "./BookingFormAdditionalInfoTab.vue?vue&type=style&index=0&id=0021b753&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021b753",
  null
  
)

export default component.exports